export default __webpack_public_path__ + "static/STUDENT_NAJ_BO-1afe7e540032725cd0806ffea17311f5.png";